import type { TFunction } from 'i18next';
import { DataLoggerDetails } from '../hooks/useDataLoggerDetails';
import { SensorConfig } from '../hooks/useCreateOrUpdateDataLogger';

export const isFirstTabComplete = (formData: Partial<DataLoggerDetails>): boolean => {
  return !!(
    formData.name &&
    formData.serialNumber &&
    formData.plcBrand &&
    formData.pollingInterval &&
    formData.plcModel &&
    formData.asset?._id &&
    formData.modbusHost &&
    formData.modbusPort &&
    formData.unitIdReal &&
    formData.startAddressReal &&
    formData.registerCountReal &&
    formData.unitIdBool &&
    formData.startAddressBool &&
    formData.registerCountBool
  );
};

export const mapSensorConfigsFromDetails = (dataLoggerDetails: DataLoggerDetails): { [key: string]: SensorConfig } => {
  const configs: { [key: string]: SensorConfig } = {};
  dataLoggerDetails.sensorConfig?.forEach((config) => {
    configs[config.sensor._id] = {
      _id: config._id,
      sensor: {
        _id: config.sensor._id,
        name: config.sensor.name,
        sensorTag: config.sensor.sensorTag || '',
      },
      referenceSensor: config.referenceSensor,
      referenceSensorPurpose: config.referenceSensorPurpose,
      start: config.start,
      end: config.end,
      type: config.type,
      sensorType: config.sensorType,      
      wordOrder: config.wordOrder,
      function: config.function,
      scalingFactor: config.scalingFactor,
      bitIndex: config.bitIndex,
      isModified: false,
      isNewEntry: false,
      isDeleted: false,
      modbusMisfireTotalizer: config.modbusMisfireTotalizer ?? false,

    };
  });
  return configs;
};

export const getSaveCancelButtonsProps = (
  activeTab: number,
  isFirstTabComplete: boolean,
  isPending: boolean,
  onNext: () => void,
  onBack: () => void,
  onSubmit: () => void,
  onClose: () => void,
  t: TFunction
) => {
  if (activeTab === 0) {
    return {
      onSave: onNext,
      onCancel: onClose,
      loading: false,
      saveValue: t('common.next', 'Next'),
      cancelValue: t('common.cancel', 'Cancel'),
      saveButtonStyle: {
        width: { xs: '50%', sm: '50%', md: '15%' },
      },
      cancelButtonStyle: {
        width: { xs: '50%', sm: '50%', md: '15%' },
      },
      disabled: !isFirstTabComplete,
    };
  } else {
    return {
      onSave: onSubmit,
      onCancel: onBack,
      loading: isPending,
      saveValue: t('common.submit', 'Submit'),
      cancelValue: t('common.back', 'Back'),
      saveButtonStyle: {
        width: { xs: '50%', sm: '50%', md: '15%' },
      },
      cancelButtonStyle: {
        width: { xs: '50%', sm: '50%', md: '15%' },
      },
    };
  }
}; 